import { Card, Image, ImagePlaceholder, Label } from './SelectableOptionCard.styles';
import type { SelectableOptionCardProps } from './SelectableOptionCard.types';

export function SelectableOptionCard({
  label,
  isSelected,
  onSelect,
  imageUrl,
  imageAlt,
  disabled = false,
}: SelectableOptionCardProps) {
  // The label already names the button, so an alt repeating it would have a
  // screen reader announce the option twice.
  const altText = imageAlt && imageAlt !== label ? imageAlt : '';

  return (
    <Card
      type="button"
      data-testid="selectable-option-card"
      data-selected={isSelected}
      data-disabled={disabled}
      aria-pressed={isSelected}
      disabled={disabled}
      onClick={onSelect}
    >
      <Label>{label}</Label>
      {imageUrl ? (
        <Image src={imageUrl} alt={altText} aria-hidden={altText ? undefined : true} />
      ) : (
        <ImagePlaceholder />
      )}
    </Card>
  );
}
